var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03049 54.0415L0.215866 58.1154C-0.383097 58.9839 0.347333 60.15 1.38943 59.9841L7.65663 58.9888L7.77837 58.9693L3.90217 52.7876L3.03537 54.0415H3.03049Z",
    fill: "#F99621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5633 57.291L20.0402 53.0122L14.7957 54.4564C14.5181 54.5344 14.3087 54.2075 14.4889 53.988L17.4155 50.3873L12.356 51.7778C12.0784 51.8559 11.869 51.529 12.0492 51.3094L15.7453 46.7622L11.9908 47.7966C11.7132 47.8746 11.5038 47.5477 11.684 47.3282L13.627 44.9375L8.88395 46.2451C8.72325 46.289 8.58689 46.1963 8.53819 46.0694L3.89746 52.7829L7.77369 58.9645L16.5195 57.5789C16.4805 57.4862 16.4854 57.3789 16.5633 57.2862V57.291Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67277 44.4396L9.64355 44.4786L10.5201 43.4004C10.2133 43.7224 9.92599 44.0688 9.67277 44.4396Z",
    fill: "#0072AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58179 45.7812C8.50875 45.8739 8.50387 45.9812 8.53796 46.0739L9.64337 44.4785L8.58179 45.7861V45.7812Z",
    fill: "#0072AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8036 0.738828L14.4693 40.6146L12.1319 42.088C11.5427 42.4589 11.0021 42.9028 10.5249 43.4005L9.64838 44.4787L8.54297 46.0742C8.59653 46.201 8.72803 46.2937 8.88872 46.2498L13.6317 44.9422L11.6888 47.3329C11.5086 47.5525 11.718 47.8794 11.9955 47.8013L15.6575 46.7914L15.75 46.767L12.054 51.3142C11.8738 51.5337 12.0832 51.8606 12.3608 51.7825L17.4203 50.392L14.4937 53.9927C14.3135 54.2123 14.5229 54.5392 14.8004 54.4611L16.3246 54.0415L20.045 53.0169L16.5681 57.2958C16.4951 57.3885 16.4902 57.4958 16.5243 57.5885L17.3813 57.4519C18.7838 57.2275 20.1278 56.7249 21.3257 55.9687L23.5901 54.544L86.8708 14.7024C88.658 13.5803 89.4371 11.3701 88.7554 9.37459C88.619 8.96964 88.468 8.57444 88.3073 8.18412C87.4844 6.17887 86.3449 4.3151 84.9424 2.66113C84.5821 2.23666 84.2071 1.81708 83.8127 1.42188C82.2106 -0.17842 79.7222 -0.4614 77.8036 0.743704V0.738828Z",
    fill: "#FFA52E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3a943d8a471bb81ac353cfc6dfad53d1.svg";
export { ForwardRef as ReactComponent };